import { RefObject, useEffect } from 'react';

type TProps<T extends HTMLElement = HTMLElement> = {
    ref: RefObject<T>;
    handler: (event: MouseEvent) => void;
};

export const useOnClickOutside = (ref: TProps['ref'], handler: TProps['handler']) => {
    useEffect(() => {
        const listener = (event: any) => {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target as Node)) {
                return;
            }
            handler(event);
        };

        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [handler, ref]);
};
